import jwt_decode from "jwt-decode";
import requireAuth from "../auth/require-auth";
import { useNavigate } from "react-router-dom";

const useAuth = (requiredRoles: string[]): boolean => {
  const navigate = useNavigate();
  const LOGGED_IN = requireAuth();
  if (LOGGED_IN) {}
  const TOKEN = localStorage.getItem("token") as string;

  if (!TOKEN) navigate("/error-server")
  
  const USER: any = jwt_decode(TOKEN);

  if (!requiredRoles) {
    return false;
  }

  const roleValide = requiredRoles.some((role) =>
    USER["cognito:groups"].find((rol: string) => rol === role)
  );

  if (roleValide === false) navigate("/acceso-restringido");
  return roleValide;
};

export { useAuth };
